import generatedComponents from './generated/index.generated';
import { Skill } from './Skill';

const Component = { ...generatedComponents, Skill };

export { Component };
